import { useMemo } from 'react';
import { useQueries } from '@tanstack/react-query';

import { widgetsConfig } from 'pages/HomePage/widgetsConfig';
import { ItemOneOf } from 'interfaces';

export const useGetHomeStatistics = (widgetKeys: string[], enabled = true) => {
  const uniqueWidgetKeys = useMemo(
    () => [...new Set(widgetKeys)].filter((key) => !!widgetsConfig[key]),
    [widgetKeys],
  );

  return useQueries({
    queries: uniqueWidgetKeys.map((key) => {
      const query = widgetsConfig[key].query;

      return {
        queryKey: query.queryKey,
        queryFn: query.queryFn,
        enabled,
      };
    }),
    combine: (results) => ({
      data: Object.fromEntries(
        uniqueWidgetKeys.map((key, i) => [
          key,
          (results[i]?.data ?? []) as ItemOneOf[],
        ]),
      ) as Record<string, ItemOneOf[]>,
      isPending: results.some((res) => res.isPending),
    }),
  });
};
